var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"downloadstatusbox"},_vm._l((_vm.downloadEvents),function(downloadEvent){return _c('DownloadProgress',{key:downloadEvent.chave,attrs:{"downloadEvent":downloadEvent}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }